/**
 * RESPONSIBILITY: draw the original Visit band — a picture and its words, the side set by position.
 *
 * THE MARKUP HERE IS THE MARKUP THIS PAGE HAS ALWAYS HAD, character for character. It is
 * the default template and what every band saved before templates existed means, so a
 * change to it is a change to the page every visitor sees. Do not tidy it. The first band
 * is picture-left, the next picture-right, and so on; a band with no picture is the full
 * width. Unlike the ministries' version it carries a heading and one optional link inside
 * its words, which is why it is its own file and not shared.
 */
import { Html } from '@framework/react';
import { Picture } from '../../commons/Picture';
import { mapTarget } from '../../commons/map-link';
import type { BandData, BandDef, BandProps } from '../../commons/bands';

function Words({ band }: { band: BandData }) {
  return (
    <div className="stack ministry-text-stack">
      {band.heading && <h2>{band.heading}</h2>}
      {band.bodyHtml && <Html className="md-body lede">{band.bodyHtml}</Html>}
      {band.linkLabel && band.linkHref && (
        <div className="btns">
          <a className="btn btn-ghost" href={band.linkHref} {...mapTarget(band.linkHref)}>{band.linkLabel}</a>
        </div>
      )}
    </div>
  );
}

function Draw({ b: band, tinted }: BandProps) {
  const cls = tinted ? 'band band-tint ministry-section-band' : 'band ministry-section-band';

  if (!band.image?.path) {
    return <section className={cls}><div className="wrap"><Words band={band} /></div></section>;
  }

  const picture = (
    <div className="ministry-pic-container">
      <Picture value={band.image} alt={band.image.alt} className="block-pic ministry-section-pic" />
    </div>
  );

  return (
    <section className={cls}>
      <div className="wrap split ministry-split-wrap">
        {tinted ? picture : <Words band={band} />}
        {tinted ? <Words band={band} /> : picture}
      </div>
    </section>
  );
}

export const visitAlternating: BandDef = {
  has: (b) => !!(b.heading || b.bodyHtml || b.image?.path),
  Draw,
};
